// -----------------------------------------------------------------------------
//  Il periodo contabile sta nella URL, non nello stato del componente.
//
//  Difetto che questo file chiude: l'hub della contabilità permetteva di
//  scegliere il mese, ma le rotte figlie sono `/contabilita/cod1/:id` — portano
//  solo l'id del partner. Ogni pagina di dettaglio ripartiva quindi da
//  `new Date()`, cioè dal mese CORRENTE. Chi guardava agosto e cliccava su un
//  partner atterrava su settembre e leggeva "0 €": non un errore di calcolo, un
//  altro mese. Valeva per tutte e otto le pagine figlie.
//
//  Mettere anno e mese nella query invece che in uno store ha due effetti che
//  qui contano: un refresh (o un link condiviso a un collega) conserva il
//  periodo, e il tasto "indietro" del browser torna al mese da cui si veniva.
//
//  Il periodo NON è mai preso per buono: `?m=13` o `?y=abc` ricadono sul mese
//  corrente invece di produrre una finestra temporale assurda.
// -----------------------------------------------------------------------------

// Estremi larghi: servono solo a scartare valori palesemente non-periodi
// (`?y=0`, `?y=1e9`), non a limitare l'uso.
const MIN_YEAR = 2000;
const MAX_YEAR = 2100;

/** Il mese corrente, con `month` 1-based come lo usa tutta la contabilità. */
export function currentPeriod() {
  const now = new Date();
  return { year: now.getFullYear(), month: now.getMonth() + 1 };
}

/**
 * Il periodo indicato dalla URL (`?y=2026&m=8`), o il mese corrente se la
 * query manca o non è valida.
 */
export function periodFromRoute(route) {
  const y = Number(route?.query?.y);
  const m = Number(route?.query?.m);
  const valido =
    Number.isInteger(y) && y >= MIN_YEAR && y <= MAX_YEAR &&
    Number.isInteger(m) && m >= 1 && m <= 12;
  return valido ? { year: y, month: m } : currentPeriod();
}

/** I parametri di query da appendere a un link verso una pagina di periodo. */
export function periodQuery(year, month) {
  return { y: String(year), m: String(month) };
}

/**
 * Riallinea la URL dopo che l'utente ha cambiato mese dalla pagina figlia.
 *
 * `replace` e non `push`: sfogliare sei mesi con le frecce non deve lasciare
 * sei voci nella cronologia, altrimenti "indietro" non riporta più all'hub.
 * Gli altri parametri di query restano dove sono.
 */
export function syncPeriodToUrl(router, route, year, month) {
  const q = periodQuery(year, month);
  if (route?.query?.y === q.y && route?.query?.m === q.m) return;
  router.replace({ query: { ...route.query, ...q } });
}
